export type LinkedInConnectionStatus =
  | 'SENT'
  | 'CONNECTED'
  | 'FAILED'
  | 'INVALID_RECIPIENT'
  | 'BLOCKED'
  | 'PENDING_RETRY'
  | 'NULL';

export type LinkedInConnectionIconVariant =
  | 'connected'
  | 'pending'
  | 'failed'
  | 'not-sent';

const STATUS_LABELS: Record<LinkedInConnectionIconVariant, string> = {
  connected: 'LinkedIn connected',
  pending: 'LinkedIn invitation pending',
  failed: 'LinkedIn invitation failed',
  'not-sent': 'LinkedIn invitation not yet sent',
};

const STATUS_TOOLTIPS: Record<LinkedInConnectionStatus, string> = {
  SENT: 'Sent',
  CONNECTED: 'Connected',
  FAILED: 'Failed',
  INVALID_RECIPIENT: 'Invalid recipient',
  BLOCKED: 'Blocked',
  PENDING_RETRY: 'Pending retry',
  NULL: 'Invitation not yet sent',
};

export function resolveLinkedInConnectionIconVariant(
  status: string | null | undefined,
): LinkedInConnectionIconVariant | null {
  if (status === undefined) {
    return null;
  }

  if (status == null || status === '' || status === 'NULL') {
    return 'not-sent';
  }

  switch (status) {
    case 'CONNECTED':
      return 'connected';
    case 'SENT':
    case 'PENDING_RETRY':
      return 'pending';
    case 'FAILED':
    case 'INVALID_RECIPIENT':
    case 'BLOCKED':
      return 'failed';
    default:
      return null;
  }
}

export function getLinkedInConnectionStatusLabel(
  status: string | null | undefined,
): string | null {
  const variant = resolveLinkedInConnectionIconVariant(status);
  return variant ? STATUS_LABELS[variant] : null;
}

export function getLinkedInConnectionStatusTooltip(
  status: string | null | undefined,
): string | null {
  if (status === undefined) {
    return null;
  }

  if (status == null || status === '' || status === 'NULL') {
    return STATUS_TOOLTIPS.NULL;
  }

  if (status in STATUS_TOOLTIPS) {
    return STATUS_TOOLTIPS[status as LinkedInConnectionStatus];
  }

  return null;
}

export function hasLinkedInConnectionStatus(
  status: string | null | undefined,
): boolean {
  return status !== undefined;
}
